import React, { useState } from 'react';
import { Bot, X } from 'lucide-react';
import ChatWidget from './ChatWidget';

const FloatingPlannerBubble = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-3">
      {open && (
        <div className="mb-2 drop-shadow-2xl">
          <ChatWidget variant="inline" onClose={() => setOpen(false)} />
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-label={open ? 'Close Nyinimu Assistant' : 'Open Nyinimu Assistant'}
        className="group relative inline-flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-[#81be00] text-white hover:bg-[#6faa00] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#81be00]"
      >
        {open ? <X className="w-6 h-6" /> : <Bot className="w-6 h-6" />}
        <span className="absolute right-16 whitespace-nowrap bg-black/80 text-white text-xs px-3 py-1.5 rounded opacity-0 group-hover:opacity-100 transition-opacity">
          {open ? 'Close chat' : 'AI Assistant'}
        </span>
      </button>
    </div>
  );
};

export default FloatingPlannerBubble;
